<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Contents</p>
<p class="toc1"><a href="#/foreword">Foreword, by Edward Looman</a></p>
<p class="toc"><a href="#/prologue">Prologue</a></p>
<p class="toc1"><a href="#/chapter01">1. The Big Plunge</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">2. The Shaky Start</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. The Nemesis</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. The <i>Star</i> Inches Forward</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. “Booming” Marion</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. The Man Behind the Pencil</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. The “Human” Editor</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. A New Partner</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">9. The Call of Politics</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. The Other Woman</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">11. The National Stage</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">12. Marion Plays Host to America</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">13. Editor in Chief</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">14. -30-</span></p>
<p class="toc1"><span href="#/epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc"><span href="#/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?11c8a78e